import { WINTER_OF_CODE } from "./data/winter-of-code";
import { HACKTOBERFEST } from "./data/hacktoberfest";
import { FACE_OFF } from "./data/face-off";

export const EVENT_DATA = [
  { event_name: "Winter of Code", data: WINTER_OF_CODE },
  { event_name: "Hacktoberfest", data: HACKTOBERFEST },
  { event_name: "Face Off", data: FACE_OFF },
];
